import { Project } from "../types/project.types";
import { UserProject } from "../types/user.types";

export const mapProjects = (userProjects: Array<UserProject>, projects?: Array<Project>): Array<Project> => {
  const result: Array<Project> = [];
  userProjects.forEach(project => {
    const find = projects?.find(item => item.id === project.projectId);
    if (!!find) {
      result.push(find);
    }
  });
  return result
}